const api = {
  state: {
    java_api: 'https://gateway.gjyymall.com', //JAVA正式环境
    //java_api: 'http://gatmall.gjyymall.com', //JAVA uat 正式环境

    php_api: 'https://php.gjyymall.com', //PHP正式环境
    //php_api: 'http://phpmall.gjyymall.com', //PHP uat 正式环境
    // php_api: 'http://192.168.1.106:80', // 贾轩本地环境

    domain_guoyunyl: ';path=/;domain=gjyunying.com', //domain 测试环境
    // domain_guoyunyl: ';path=/;domain=gjyunying.cn', //domain  预线上环境 和 线上环境
  }
};

export default api



// WEBPACK FOOTER //
// ./src/store/modules/api.js